// extracted by mini-css-extract-plugin
module.exports = {"link":"link-23a2K","link_noUnderline":"link_noUnderline-uC0G0"};